import React from 'react';
import { DELETE_MAILBOX_MUTATION } from '../../../api/mutations';
import { ICreateMailboxData } from '../forms/CreateMailboxForm';
import { useMutation } from '@apollo/client';
import { MAILBOXES } from '@/api/queries';

const useDeleteMailbox = () => {
    const [ deleteMailbox ] = useMutation(DELETE_MAILBOX_MUTATION, {
        refetchQueries: [MAILBOXES]
    })


    const handleDeleteMailbox = async (values: { mailboxId: string }) => {

        const req = await deleteMailbox({ variables: values });

        if (req.data?.deleteMailbox?.message) {
            if (req.data.deleteMailbox.__typename == "ErrorType") return console.log(req.data?.createMailbox?.message);
            return req.data?.deleteMailbox?.message
        }

        req.errors && console.log(req.errors.toString())
    }

    return {
        deleteMailbox: handleDeleteMailbox
    }
}

export default useDeleteMailbox;